module.exports = __webpack_public_path__ + "img/profile-avatar.1e8c80cc.png";